import base from "./base/index"; // 接口域名列表
import axios from "../utils/http"; // 导入http中创建的axios实例
import qs from "qs"; // 按需导入qs模块:post请求用到
const measuringClassification = {
  /**
   * 创建测量点分类
   * @param {*} companyId 公司id，NULL/0 表示本公司
   * @param {*} name 测量点名称,不能为空字符串
   * @param {*} displayName 显示名称，不能为空字符串
   */
  createMeasureClass(companyId, name, displayName) {
    let params = {
      companyId: companyId,
      name: name,
      displayName: displayName,
    };
    return axios.post(
      base.measuringClassification.createMeasureClass,
      qs.stringify(params)
    );
  },
  /**
   * 修改测量点分类
   * @param {*} id 类id
   * @param {*} name 测量点名称,不能为空字符串
   * @param {*} displayName 显示名称，不能为空字符串
   */
  modifyMeasureClass(id, name, displayName) {
    let params = {
      id: id,
      name: name,
      displayName: displayName,
    };
    return axios.post(
      base.measuringClassification.modifyMeasureClass,
      qs.stringify(params)
    );
  },
  /**
   * 删除测量点分类
   * @param {*} id 类id
   */
  deleteMeasureClass(id) {
    let params = {
      id: id,
    };
    return axios.post(
      base.measuringClassification.deleteMeasureClass,
      qs.stringify(params)
    );
  },
  /**
   * 查询测量点分类
   * @param {*} id 类id
   */
  getMeasureClass(id) {
    let params = {
      id: id,
    };
    return axios.get(base.measuringClassification.getMeasureClass, {
      params: params,
    });
  },
  /**
   * 查询测量点分类
   * @param {*} companyId 公司id
   */
  getMeasureClasses2(companyId) {
    let params = {
      companyId: companyId,
    };
    return axios.get(base.measuringClassification.getMeasureClasses2, {
      params: params,
    });
  },
  /**
   * 从组中查询测量点
   * @param {*} companyId 公司id
   * @param {*} className 类名
   * @param {*} groups 组名
   */
  getMeasuresFromGroup2(companyId, className, groups) {
    let params = {
      companyId: companyId,
      className: className,
      groups: JSON.stringify(groups),
    };
    return axios.post(
      base.measuringClassification.getMeasuresFromGroup2,
      qs.stringify(params)
    );
  },
  /**
   * 从组中查询测量点
   * @param {*} groups [groupId1,  ..]
   */
  getMeasuresFromGroup(groups) {
    let params = {
      groups: JSON.stringify(groups),
    };
    return axios.post(
      base.measuringClassification.getMeasuresFromGroup,
      qs.stringify(params)
    );
  },
  /**
   * 创建测量点分类分组
   * @param {*} classId 类id
   * @param {*} name 测量点名称,不能为空字符串
   * @param {*} displayName 显示名称，不能为空字符串
   */
  addMeasureGroup(classId, name, displayName) {
    let params = {
      classId: classId,
      name: name,
      displayName: displayName,
    };
    return axios.post(
      base.measuringClassification.addMeasureGroup,
      qs.stringify(params)
    );
  },
  /**
   * 修改测量点分类f分组
   * @param {*} groupId 组id
   * @param {*} name 测量点名称,不能为空字符串
   * @param {*} displayName 显示名称，不能为空字符串
   */
  modifyMeasureGroup(groupId, name, displayName) {
    let params = {
      groupId: groupId,
      name: name,
      displayName: displayName,
    };
    return axios.post(
      base.measuringClassification.modifyMeasureGroup,
      qs.stringify(params)
    );
  },
  /**
   * 删除测量点分类f分组
   * @param {*} groupId 组id
   */
  deleteMeasureGroup(groupId) {
    let params = {
      groupId: groupId,
    };
    return axios.post(
      base.measuringClassification.deleteMeasureGroup,
      qs.stringify(params)
    );
  },
  /**
   * 查询测量点分类分组
   * @param {*} id 节点id
   */
  getMeasureGroup(id) {
    let params = {
      id: id,
    };
    return axios.get(base.measuringClassification.getMeasureGroup, {
      params: params,
    });
  },
  /**
   * 查询测量点分类分组
   * @param {*} id 节点id
   */
  getMeasureGroup2(id) {
    let params = {
      id: id,
    };
    return axios.get(base.measuringClassification.getMeasureGroup2, {
      params: params,
    });
  },
  /**
   * 增加测量点参数
   * @param {*} measuresId 测量点id
   * @param {*} groupId 组id
   */
  setMeasuresInGroup(measuresId, groupId) {
    let params = {
      measuresId: JSON.stringify(measuresId),
      groupId: groupId,
    };
    return axios.post(
      base.measuringClassification.setMeasuresInGroup,
      qs.stringify(params)
    );
  },
  /**
   * 从组移除测量点
   * @param {*} measureId 测量点id
   * @param {*} groupId 组id
   */
  removeMeasuresFromGroup(measuresId, groupId) {
    let params = {
      measuresId: JSON.stringify(measuresId),
      groupId: groupId,
    };
    return axios.post(
      base.measuringClassification.removeMeasuresFromGroup,
      qs.stringify(params)
    );
  },
  /**
   * 从组查询交集测量点
   * @param {*} filter  [{calssId, groups:[id1, id2, ..]}, ..]
   */
  getIntersectingMeasuresFromClass(filter) {
    let params = {
      filter: JSON.stringify(filter),
    };
    return axios.post(
      base.measuringClassification.getIntersectingMeasuresFromClass,
      qs.stringify(params)
    );
  },
  /**
   * 查询计量点分类分组信息
   * @param {*} measuresId  [{calssId, groups:[id1, id2, ..]}, ..]
   */
  getClassesOfMeasures(measuresId) {
    let params = {
      measuresId: JSON.stringify(measuresId),
    };
    return axios.post(
      base.measuringClassification.getClassesOfMeasures,
      qs.stringify(params)
    );
  },
  /**
   * 查询分类分组信息
   * @param {*} companyId  [{calssId, groups:[id1, id2, ..]}, ..]
   */
  getMeasureGroup4(companyId) {
    let params = {
      companyId: companyId,
    };
    return axios.post(
      base.measuringClassification.getMeasureGroup4,
      qs.stringify(params)
    );
  },
};

export default measuringClassification;
